import React from 'react';
import classnames from 'classnames';
import './ErrorAlert.pcss';
import errorIcon from 'assets/baseline-error_outline.svg';

type OuterProps = {
  className?: string;
  message?: string;
  children?: any;
};

export const ErrorAlert = ({ message, children, className }: OuterProps) => {
  const error = message || children;

  return (
    <div className={classnames('c-error-alert', className)}>
      <img src={errorIcon} alt="" />
      <div className="c-error-alert__message">{error}</div>
    </div>
  );
};
